module.exports = __webpack_public_path__ + "img/ddm1.ddd3036c.png";